(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["true-spec-newsletter"]) return;
  try {
    
  if (!customElements.get('true-spec-newsletter')) {
    customElements.define('true-spec-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const dialog = this.querySelector('dialog');
        if (!dialog || !dialog.showModal) return;
        const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
        const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
        const sessionKey = 'ts-newsletter-shown';
        const dismissKey = 'ts-newsletter-dismissed';
        const doneKey = 'ts-newsletter-completed';
        const open = () => {
          if (dialog.open) return;
          dialog.showModal();
          write('sessionStorage', sessionKey, '1');
        };
        this.querySelector('[data-newsletter-open]').addEventListener('click', open, { signal });
        this.querySelector('[data-newsletter-close]').addEventListener('click', () => dialog.close(), { signal });
        dialog.addEventListener('close', () => write('localStorage', dismissKey, String(Date.now())), { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, { signal });
        if (this.querySelector('[data-newsletter-success]')) {
          write('localStorage', doneKey, '1');
          open();
          return;
        }
        if (this.querySelector('[data-newsletter-errors]')) { open(); return; }
        if (this.dataset.designMode === 'true' || this.dataset.subscribed === 'true') return;
        if (read('sessionStorage', sessionKey) || read('localStorage', doneKey)) return;
        const dismissed = Number(read('localStorage', dismissKey));
        if (dismissed && Date.now() - dismissed < 7 * 86400000) return;
        let ready = false;
        const maybeOpen = () => {
          if (!ready || read('sessionStorage', sessionKey)) return;
          const distance = document.documentElement.scrollHeight - innerHeight;
          if (distance > 0 && scrollY / distance < 0.35) return;
          if (document.querySelector('dialog[open], cart-drawer.active, details[open]')) return;
          if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
          open();
        };
        this.timer = setTimeout(() => { ready = true; maybeOpen(); }, 12000);
        window.addEventListener('scroll', maybeOpen, { passive: true, signal });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-header"]) return;
  try {
    
if (!customElements.get('true-spec-header')) {
  customElements.define('true-spec-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.copy = JSON.parse(this.querySelector('[data-ts-header-copy]').textContent);
      this.dialog = this.querySelector('#vehicle-dialog');
      this.make = this.querySelector('#make');
      this.model = this.querySelector('#model');
      this.button = this.querySelector('#garage-button');
      this.menu = this.querySelector('#menu-button');
      this.querySelector('header').setAttribute('data-ts-ready','');
      this.button.hidden = false;
      this.menu.hidden = false;
      this.models = {
        BMW:['M3 · E90','M3 · E92','M3 · E93','M3 · F80','M4 · F82 / F83','M2 · G87','M3 · G80','M4 · G82 / G83',`${this.copy.other} BMW · ${this.copy.decals}`],
        Toyota:['Supra · A90 / A91',`${this.copy.other} Toyota · ${this.copy.decals}`],
        Porsche:[`${this.copy.all_models} Porsche · ${this.copy.decals}`]
      };
      this.vehicle = null;
      try { const v=JSON.parse(localStorage.getItem('truespec-vehicle')); if(v && [...this.make.options].some(o=>o.value===v.make) && this.getModels(v.make).includes(v.model))this.vehicle=v; } catch {}
      this.refreshLabel();
      this.button.addEventListener('click',()=>this.open(),options);
      this.querySelector('.close').addEventListener('click',()=>this.dialog.close(),options);
      this.make.addEventListener('change',()=>this.updateModels(),options);
      this.querySelector('#clear-vehicle').addEventListener('click',()=>this.clear(),options);
      this.querySelector('#vehicle-form').addEventListener('submit',event=>{
        event.preventDefault();
        if(!this.make.value || !this.getModels(this.make.value).includes(this.model.value))return;
        this.vehicle={make:this.make.value,model:this.model.value};
        try {localStorage.setItem('truespec-vehicle',JSON.stringify(this.vehicle));}catch{}
        this.dialog.close();this.refreshLabel();
        window.dispatchEvent(new CustomEvent('ts:vehiclechange',{detail:this.vehicle}));
        if(document.querySelector('true-spec-storefront'))location.hash='shop';
        else location.assign(this.dataset.rootUrl+'#shop');
      },options);
      this.menu.addEventListener('click',()=>{
        const open=this.querySelector('header').classList.toggle('open');this.menu.setAttribute('aria-expanded',String(open));
      },options);
      this.addEventListener('click',event=>{
        if(event.target.closest('nav a')){this.querySelector('header').classList.remove('open');this.menu.setAttribute('aria-expanded','false');}
      },options);
      window.addEventListener('ts:opengarage',()=>this.open(),options);
      window.addEventListener('ts:clearvehicle',()=>this.clear(),options);
    }
    getModels(make){return this.models[make] || [`${this.copy.all_models} · ${this.copy.decals}`];}
    updateModels(selected=''){
      this.model.replaceChildren(new Option(this.copy.select_model,''));
      for(const value of this.getModels(this.make.value))this.model.add(new Option(value,value,false,value===selected));
      this.model.disabled=!this.make.value;
    }
    refreshLabel(){
      let label=this.button.querySelector('[data-ts-garage-label]');
      if(!label){label=document.createElement('span');label.dataset.tsGarageLabel='';this.button.firstChild.replaceWith(label);}
      label.textContent=this.vehicle ? this.vehicle.make : this.copy.select_vehicle;
    }
    open(){if(this.vehicle){this.make.value=this.vehicle.make;this.updateModels(this.vehicle.model);}if(!this.dialog.open)this.dialog.showModal();}
    clear(){
      this.vehicle=null;try{localStorage.removeItem('truespec-vehicle');}catch{}
      this.dialog.close();this.refreshLabel();window.dispatchEvent(new CustomEvent('ts:vehiclechange',{detail:null}));
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-storefront"]) return;
  try {
    
if (!customElements.get('true-spec-storefront')) {
  customElements.define('true-spec-storefront', class extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.copy=JSON.parse(this.querySelector('[data-ts-page-copy]').textContent);
      this.vehicle=null;
      try{const v=JSON.parse(localStorage.getItem('truespec-vehicle'));if(v&&typeof v.make==='string'&&typeof v.model==='string')this.vehicle=v;}catch{}
      const options={signal:this.controller.signal};
      window.addEventListener('hashchange',()=>{this.render();document.getElementById('MainContent')?.focus({preventScroll:true});window.scrollTo({top:0,behavior:'instant'});},options);
      window.addEventListener('ts:vehiclechange',event=>{this.vehicle=event.detail;this.render();},options);
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-garage],[data-ts-garage]'))window.dispatchEvent(new CustomEvent('ts:opengarage'));
        if(event.target.closest('[data-ts-clear]'))window.dispatchEvent(new CustomEvent('ts:clearvehicle'));
      },options);
      this.render();
      this.loadRemainingProducts();
    }
    async loadRemainingProducts(){
      const signal=this.controller.signal;
      const seen=new Set();
      try{
        let next=this.querySelector('[data-ts-next]');
        while(next&&!signal.aborted){
          const url=new URL(next.href,location.href);
          url.hash='';
          if(url.origin!==location.origin||seen.has(url.href))break;
          seen.add(url.href);
          const response=await fetch(url.href,{signal});
          if(!response.ok)throw new Error('Catalog request failed');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const catalog=doc.querySelector('[data-ts-catalog]');
          if(!catalog)throw new Error('Catalog missing');
          const existing=new Set([...this.querySelectorAll('[data-ts-catalog] [data-handle]')].map(card=>card.dataset.handle));
          for(const card of catalog.querySelectorAll('[data-ts-product]'))if(!existing.has(card.dataset.handle))next.before(card);
          const following=catalog.querySelector('[data-ts-next]');
          if(following)next.replaceWith(following);else next.remove();
          next=this.querySelector('[data-ts-next]');
          this.render();
        }
      }catch(error){if(error.name!=='AbortError')console.warn('Additional products can be opened using the next-page link.');}
    }
    matches(card){
      const v=this.vehicle;if(!v)return true;
      const category=card.dataset.category;const handle=card.dataset.handle;
      if(category==='apparel'||category==='posters'||category==='other')return true;
      if(category==='exhaust'){
        if(v.make!=='BMW')return false;
        const chassis=v.model.match(/\b[EFG]\d{2}\b/g)||[];
        const fitment=(card.dataset.fitment||'').split(' ');
        if(fitment.some(Boolean))return chassis.some(code=>fitment.includes(code.toLowerCase()));
        if(/F80|F82|F83/.test(v.model))return handle.startsWith('f8x-');
        if(/G87|G80|G82|G83/.test(v.model))return handle==='untitled-feb26_16-16';
        return false;
      }
      const target=v.make==='BMW'||v.make==='Toyota'&&v.model.startsWith('Supra')?'custom-sticker':v.make==='Porsche'?'porsche-decal':['Audi','Volkswagen','Mercedes-Benz'].includes(v.make)?'euro-decal':['Ford','Chevrolet','Dodge'].includes(v.make)?'american-decal':'jdm-decal';
      return handle===target;
    }
    render(){
      let route=location.hash.slice(1)||'home';
      if(!['home','marketplace',...Object.keys(this.copy.titles)].includes(route))route='home';
      const category=route==='home'||route==='marketplace'?'shop':route;
      for(const view of this.querySelectorAll('[data-ts-view]'))view.hidden=view.dataset.tsView!==(route==='home'?'home':route==='marketplace'?'marketplace':'catalog');
      this.querySelector('[data-ts-category-title]').textContent=this.copy.titles[category];
      this.querySelector('[data-ts-category-description]').textContent=this.copy.descriptions[category];
      this.querySelector('[data-ts-category-crumb]').textContent=this.copy.titles[category];
      const heading=this.querySelector('[data-ts-view="catalog"] .page-heading');heading.classList.toggle('collection-photo',category==='decals');
      this.querySelector('[data-ts-category-photo]').hidden=category!=='decals';
      const chip=this.querySelector('[data-ts-vehicle-chip]');chip.hidden=!this.vehicle;
      this.querySelector('[data-ts-selected-vehicle]').textContent=this.vehicle?`${this.vehicle.make} ${this.vehicle.model}`:'';
      for(const card of this.querySelectorAll('[data-ts-product]'))card.hidden=!this.matches(card)||(!!card.closest('[data-ts-catalog]')&&category!=='shop'&&card.dataset.category!==category);
      const count=[...this.querySelectorAll('[data-ts-catalog] [data-ts-product]')].filter(card=>!card.hidden).length;
      this.querySelector('[data-ts-count]').textContent=`${count} ${this.copy.count}`;
      this.querySelector('[data-ts-empty]').hidden=count!==0;
      for(const link of this.querySelectorAll('.filter')){const current=link.getAttribute('href')==='#'+category;link.classList.toggle('active',current);if(current)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');}
      document.title=(route==='home'?this.copy.home_title:route==='marketplace'?this.copy.market_title:this.copy.titles[category])+' — True Spec';
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}


  } catch(e) { console.error(e); }
})();
})();
